import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoGraduationCapEducation = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>GraduationCapEducation</title>
    <path
      d="M6.34 14.76v5.271c0 .884.51 1.69 1.31 2.067l7.373 3.482a2.286 2.286 0 0 0 1.953 0l7.374-3.482a2.286 2.286 0 0 0 1.31-2.067v-5.272"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.491 12.345 17.32 6.856a3.429 3.429 0 0 0-2.637 0L2.776 11.817a.571.571 0 0 0 0 1.055l11.906 4.96a3.428 3.428 0 0 0 2.637 0l13.172-5.488Zm0 0v7.245"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoGraduationCapEducation;
